import './bootstrap'; // your existing early‐init
import * as ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@descope/react-sdk';
import { Provider as ReduxProvider } from 'react-redux';
import store from '@center-pwa/store/store';
import { PrimeReactProvider } from 'primereact/api';
import App from './app/app';
import LoginPage from './app/pages/LoginPage';
import WaitlistStatusPage from './app/pages/WaitlistStatusPage';
import SessionEndGuard from './app/routing/SessionEndGuard';
import ThemeDetection from './app/routing/ThemeDetection';
import { I18nextProvider, i18n } from 'localization';
import { SessionScopedImpersonationProvider } from './app/context/SessionScopedImpersonationProvider';
import { StatsigClientProvider } from '@center-technologies/analytics';

// ← import your two new contexts
import { SessionDataProvider } from './app/context/SessionDataContext';
import { primeReactConfig } from 'design-system/my-lib';
import { DescopeApiClientsProvider as ApiClientsProvider } from './app/context/DescopeApiClientsProvider';
import { UserIdentityReduxProvider } from './app/context/UserIdentityReduxProvider';
import { IdentityPreferencesReduxProvider } from './app/context/IdentityPreferencesReduxProvider';
import { apiAnalyticsLogger } from './app/utils/analyticsConfig';
import { centerPwaActiveSubjectAdapter } from './app/utils/activeSubjectAdapter';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <PrimeReactProvider value={primeReactConfig}>
    <HashRouter>
      <AuthProvider
        projectId={process.env.REACT_APP_DESCOPE_PROJECT_ID || ''}
        baseUrl={process.env.REACT_APP_DESCOPE_BASE_URL}
      >
        <ReduxProvider store={store}>
          <I18nextProvider i18n={i18n}>
            <SessionDataProvider>
              <SessionScopedImpersonationProvider> {/* Must be BEFORE ApiClientsProvider */}
                <ApiClientsProvider
                  onResponse={apiAnalyticsLogger.onResponse}
                  onError={apiAnalyticsLogger.onError}
                >
                  <IdentityPreferencesReduxProvider>
                    <UserIdentityReduxProvider>
                      <StatsigClientProvider activeSubjectAdapter={centerPwaActiveSubjectAdapter}>
                        <ThemeDetection />
                        <Routes>
                          <Route path="/login" element={<LoginPage />} />
                          <Route path="/waitlist" element={<WaitlistStatusPage />} />
                          <Route
                            path="/*"
                            element={
                              <SessionEndGuard>
                                <App />
                              </SessionEndGuard>
                            }
                          />
                        </Routes>
                      </StatsigClientProvider>
                    </UserIdentityReduxProvider>
                  </IdentityPreferencesReduxProvider>
                </ApiClientsProvider>
              </SessionScopedImpersonationProvider>
            </SessionDataProvider>
          </I18nextProvider>
        </ReduxProvider>
      </AuthProvider>
    </HashRouter>
  </PrimeReactProvider>
);
